export { default } from './AnimacioEclipsi';
